import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postUser = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/user`, data: payload });

  return data;
};

export default postUser;
